// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { SetCartDatesHasErrorsParameter } from "@store/Framework/Store/Greif/Pages/Cart/RequestedDates/Handlers/SetCartDatesHasError";
import { SetCopiedRequestedDateRowParameter } from "@store/Framework/Store/Greif/Pages/Cart/RequestedDates/Handlers/SetCopiedRequestedDateRow";
import { SetDisplayCartDateErrorsParameter } from "@store/Framework/Store/Greif/Pages/Cart/RequestedDates/Handlers/SetDisplayCartDateErrors";
import { SetIsEditingDatesParameter } from "@store/Framework/Store/Greif/Pages/Cart/RequestedDates/Handlers/UpdateIsEditingDates";
import RequestedDateState from "@store/Framework/Store/Greif/Pages/Cart/RequestedDates/RequestedDateState";
import { Draft } from "immer";

const initialState: RequestedDateState = {
    isEditingDate: true,
    hasErrors: false,
    displayCartDateErrors: false,
    copiedRow: undefined,
};

const actions = {
    "Greif/Pages/CartRequestedDate/SetIsEditingDate": (
        draft: Draft<RequestedDateState>,
        action: SetIsEditingDatesParameter,
    ) => {
        draft.isEditingDate = action.isEditingDate;
    },
    "Greif/Pages/CartRequestedDate/SetCartDatesHasError": (
        draft: Draft<RequestedDateState>,
        action: SetCartDatesHasErrorsParameter,
    ) => {
        draft.hasErrors = action.hasErrors;
    },
    "Greif/Pages/CartRequestedDate/SetDisplayCartDateErrors": (
        draft: Draft<RequestedDateState>,
        action: SetDisplayCartDateErrorsParameter,
    ) => {
        draft.displayCartDateErrors = action.displayCartDateErrors;
    },
    "Greif/Pages/CartRequestedDate/SetCopiedRow": (
        draft: Draft<RequestedDateState>,
        action: SetCopiedRequestedDateRowParameter,
    ) => {
        draft.copiedRow = action.copiedRow;
    },
    "Greif/Pages/CartRequestedDate/ClearCopiedRow": (draft: Draft<RequestedDateState>) => {
        draft.copiedRow = undefined;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifCartPagesReducerRequestedDateActions = Parameters<typeof reducer>[1];
export default reducer;
